import { readFromEnv, Env } from '@cinch-nx/environments'
import axios from 'axios'
import { datadogRum } from '@datadog/browser-rum'

const awinServiceClient = axios.create({
  baseURL: readFromEnv(Env.AwinServiceUrl),
  validateStatus: () => true,
})

export const sendConfirmation = async (
  request: SendAwinConfirmationRequest,
) => {
  try {
    const { status } = await awinServiceClient.post('/', request)

    if (status === 200) {
      datadogRum.addAction(
        'Cinch Servicing: Send AWIN Confirmation - Success',
        {
          bookingRef: request.orderId,
          statusCode: status,
        },
      )

      return true
    } else {
      datadogRum.addError(
        new Error('Cinch Servicing: Send AWIN Confirmation - Failure'),
        {
          bookingRef: request.orderId,
          statusCode: status,
        },
      )
    }

    return false
  } catch (error) {
    datadogRum.addError(
      new Error('Cinch Servicing: Send AWIN Confirmation - Error'),
      {
        bookingRef: request.orderId,
        error: error,
      },
    )
    return false
  }
}

export type SendAwinConfirmationRequest = {
  orderId: string
  orderTotalInPence: number
  userId: string
  clickId: string
  channel: string
  commissionGroup: string
  voucherCode?: string
  testMode?: boolean
  platformType?: 'app' | 'web'
}
